import { render } from "./UserDetail.vue?vue&type=template&id=1bd053ba"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"
script.render = render

export default script